// extracted by mini-css-extract-plugin
module.exports = {"header":"Header--header--3y4vL","header__logo":"Header--header__logo--206ir","header__navigation":"Header--header__navigation--1gMDL"};